var map = {
	"./sticker_jelly_number_0.png": 4477,
	"./sticker_jelly_number_1.png": 442,
	"./sticker_jelly_number_2.png": 9342,
	"./sticker_jelly_number_3.png": 1776,
	"./sticker_jelly_number_4.png": 3193,
	"./sticker_jelly_number_5.png": 6946,
	"./sticker_jelly_number_6.png": 5260,
	"./sticker_jelly_number_7.png": 8227,
	"./sticker_jelly_number_8.png": 3020,
	"./sticker_jelly_number_9.png": 1246
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6636;